export const mapStateToProps = state => {
    return {
        accounts: state.accounts,
        EcoCoin: state.contracts.EcoCoin,
        drizzleStatus: state.drizzleStatus,
    }
}